import styled from 'styled-components';

export const SkillsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const SkillsWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 72px 50px;

  @media screen and (max-width: 786px) {
    padding: 48px 20px;
  }
`;

export const SkillsContent = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 18px 12px;

  @media screen and (max-width: 786px) {
    justify-content: flex-start;
  }
`;

export const SkillsH1 = styled.h1`
  font-size: 2.5rem;
  color: #010606;
  margin-bottom: 24px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const SkillTag = styled.h2`
  font-size: 1rem;
  color: #010606;
  white-space: nowrap;
  background: #fff;
  border: 1px solid #010606;
  border-radius: 999px;
  padding: 12px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
